export const CASE_STATUS_DRAFTED = "DRAFT";
export const CASE_STATUS_CREATED = "CREATED";
export const CASE_STATUS_SUBMITTED = "SUBMITED";
export const CASE_STATUS_COMPLETED = "COMPLETED";
export const CASE_STATUS_ARCHIVED = "ARCHIVED";